import React from 'react';
import { useTranslation } from 'react-i18next';
import FoldableTagList from '@wix/da-ds/pkg/TagList/FoldableTagList';
import s from './JournalTags.scss';
export const JournalTags = ({ tags })=>{
    const { t } = useTranslation();
    return tags ? /*#__PURE__*/ React.createElement("div", {
        className: s['tags']
    }, /*#__PURE__*/ React.createElement(FoldableTagList, {
        tags: tags,
        moreLabel: /*#__PURE__*/ React.createElement("span", {
            title: t('common.showMore'),
            "aria-label": t('common.showMore')
        }, t('common.moreEllipsis'))
    })) : null;
};
JournalTags.displayName = 'JournalTags';
export default JournalTags;
